// Safe access utility functions to prevent undefined access errors
export const safeAccess = (obj: any, path: string, defaultValue: any = undefined) => {
  try {
    const keys = path.split('.');
    let result = obj;
    for (const key of keys) {
      if (result == null) return defaultValue;
      result = result[key];
    }
    return result ?? defaultValue;
  } catch {
    return defaultValue;
  }
};

export const safeLength = (arr: any[] | null | undefined): number => {
  return Array.isArray(arr) ? arr.length : 0;
};

export const safeDateFormat = (date: any, defaultValue: string = 'Unknown'): string => {
  if (!date) return defaultValue;
  try {
    return new Date(date).toLocaleDateString();
  } catch {
    return defaultValue;
  }
};

export const safeNumber = (value: any, defaultValue: number = 0): number => {
  const num = Number(value);
  return isNaN(num) ? defaultValue : num;
};
